import React from 'react';
import './AppLoader.css';
import logo from '../Assets/logo_big.png';

const AppLoader = () => {
  return (
    <div className="app-loader" role="status" aria-live="polite" aria-label="Loading NepliShop">
      <div className="app-loader__spinner">
        <img src={logo} alt="NepliShop" className="app-loader__logo" loading="eager" decoding="async" fetchpriority="high" width="46" height="46" />
      </div>
      <p className="app-loader__text">Loading NepliShop...</p>
    </div>
  );
};

export default AppLoader;
